// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total-employees {
  width: 250px; /* Fixed width */
    height: 320px; /* Fixed height */
    text-align: center;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    overflow: hidden;
}

.total-employees h3 {
  font-size: 20px; /* Font size for the title */
  font-weight: bold;
  color: #0a0a0a; /* Dark color for title */
  text-align: center;
  margin-top: 0px; /* Spacing below the title */
  padding-top: 0;
}

.admindashtotalemployee-chart {
  width: 100%; /* Full width for the chart */
  height: 250px; /* Fixed height for the chart */
  display: flex;
  justify-content: center; /* Center chart horizontally */
  align-items: center; /* Center chart vertically */
  background: white; /* Light background for the chart area */
  border-radius: 8px; /* Rounded corners for the chart */
  
}

.total-employees .legend-container {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* Center the legend items */
  gap: 15px;
}

.total-employees .legend-item {
  display: flex;
  align-items: center;
  font-size: 12px; /* Small font size for legend items */
}

.total-employees .legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%; /* Circular color legend */
  margin-right: 5px; /* Spacing between the color circle and text */
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/TotalEmployee.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE,gBAAgB;IAC5B,aAAa,EAAE,iBAAiB;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;EACE,eAAe,EAAE,4BAA4B;EAC7C,iBAAiB;EACjB,cAAc,EAAE,yBAAyB;EACzC,kBAAkB;EAClB,eAAe,EAAE,4BAA4B;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,6BAA6B;EAC1C,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,uBAAuB,EAAE,8BAA8B;EACvD,mBAAmB,EAAE,4BAA4B;EACjD,iBAAiB,EAAE,wCAAwC;EAC3D,kBAAkB,EAAE,kCAAkC;;AAExD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB,EAAE,4BAA4B;EACrD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,0BAA0B;EAC9C,iBAAiB,EAAE,8CAA8C;AACnE","sourcesContent":[".total-employees {\n  width: 250px; /* Fixed width */\n    height: 320px; /* Fixed height */\n    text-align: center;\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    overflow: hidden;\n}\n\n.total-employees h3 {\n  font-size: 20px; /* Font size for the title */\n  font-weight: bold;\n  color: #0a0a0a; /* Dark color for title */\n  text-align: center;\n  margin-top: 0px; /* Spacing below the title */\n  padding-top: 0;\n}\n\n.admindashtotalemployee-chart {\n  width: 100%; /* Full width for the chart */\n  height: 250px; /* Fixed height for the chart */\n  display: flex;\n  justify-content: center; /* Center chart horizontally */\n  align-items: center; /* Center chart vertically */\n  background: white; /* Light background for the chart area */\n  border-radius: 8px; /* Rounded corners for the chart */\n  \n}\n\n.total-employees .legend-container {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center; /* Center the legend items */\n  gap: 15px;\n}\n\n.total-employees .legend-item {\n  display: flex;\n  align-items: center;\n  font-size: 12px; /* Small font size for legend items */\n}\n\n.total-employees .legend-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%; /* Circular color legend */\n  margin-right: 5px; /* Spacing between the color circle and text */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
